<script setup>

import {defineProps} from 'vue'

const props = defineProps({
  classes: {type: String, default: 'text-gray-400 text-hover-primary'},
  withTotal: {type: Boolean, default: false},
  total: { type: Number, default: 0 },
  addComment: Function,
})



</script>

<template>
  <div @click.prevent="addComment"
       class="card d-flex flex-row align-items-center shadow rounded-sm w-120px p-2 fw-bold"
       :class="classes"
  >
    <span v-if="withTotal" class="me-2">{{ total }}</span><i class="fa fa-comment cursor-pointer" :class="classes" style="font-size: 1.2rem"></i>
  </div>
</template>

<style scoped>

</style>